<template>
	<BaseLayout
		:footer-full="true"
		:include-padding="true"
		:background-color-class="'bg-color-white'"
		:content-full-height="true"
	>
		<div class="container">
			<h1 class="heading-1">Press &amp; Media</h1>
			<div class="display-flex-md gutters-300-md mt-100 mt-200-md">
				<div class="col-6-md">
					<div class="module height-100">
						<div class="module-header">
							<h2 class="heading-5">Media resources</h2>
						</div>
						<div class="module-section">
							<p class="delta-md">
								Download a high&ndash;res version of the Fundrise logo and open source files for
								Fundrise&rsquo;s&nbsp;font.
							</p>

							<div class="media-button-group">
								<BaseLink
									v-for="(resource, r) in mediaResources"
									:key="r"
									class="button zeta-smo eta-mdo epsilon-lg mt-100"
									:link="resource"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6-md mt-100-smo">
					<div class="module height-100">
						<div class="module-header">
							<h2 class="heading-5">Media contact</h2>
						</div>
						<div class="module-section">
							<p class="delta-md">
								Jon Carden<br />
								media@fundrise.com<br />
								(202) 584-0550
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { Link } from 'types/layout';
import { useHead } from '@unhead/vue';

const mediaResources: Array<Link> = [
	{
		text: 'Font',
		href: `${appCloudfrontPath}/website-documents/Source_Sans_Pro.zip`,
		target: '_blank'
	},
	{
		text: 'Logo',
		href: `${appCloudfrontPath}/website-documents/fundrise-logo.pdf`,
		target: '_blank'
	},
	{
		text: 'Media kit',
		href: `${appCloudfrontPath}/website-documents/MediaKit2022.pdf`,
		target: '_blank'
	}
];

const metaTitle = 'Press & Media';
const metaDescription = 'Fundrise Press & Media.';

function setup(): void {
	useHead({
		title: metaTitle,
		meta: [
			{ property: 'og:title', content: metaTitle },
			{ name: 'description', content: metaDescription },
			{ property: 'og:description', content: metaDescription }
		]
	});
}

setup();
</script>

<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.media-button-group {
	@media screen and (max-width: $md-start - 1) {
		display: flex;
		flex-direction: column;
	}
	.button + .button {
		@include respond-to(md) {
			margin-left: 0.5rem;
		}
		@include respond-to(lg) {
			margin-left: 1rem;
		}
	}
}
</style>
